<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.querySelector('.list-unstyled.list-social.clearfix');
  if (targetElement) {
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0536/3964/3329/files/stripe-payment.png?v=1745910990';
    img.className = 'trust-badge-image';
    img.alt = 'Secure payments';
    img.style.width = '200px';
    img.style.marginTop = '24px';
    targetElement.insertAdjacentElement('afterend', img);
  } 
});
